import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import * as eventRoutines from '../../Containers/Events/eventRoutines'
import AlertUser from '../../Containers/AlertUser';
import EventHero from './EventHero';
import Module from '../../Containers/WrappedAtoms/Module';
import SimpleButton from '../Atoms/SimpleButton';
import SimpleStat from '../Atoms/SimpleStat/SimpleStat';
import SimpleToggle from '../Atoms/SimpleToggle/';
import SimpleToggleBlock from '../Atoms/SimpleToggleBlock/SimpleToggleBlock';
import UserSync from './UserSync';
import {useDispatch} from "react-redux";
const Dashboard = (props: any) => {
    const {
        active_event,
        active_user_count,
        invitee_count,
        isChannelsEnabled,
        isPeerToPeerEnabled,
        isPeerToPeerVideoChatEnabled,
        match,
        moduleCounts,
        registrant_count,
        saveEventHeroImage,
        updateActiveUsers,
        updateChannelsModule,
        updatePeerToPeerModule,
        updatePeerToPeerVideoChat
    } = props;
    const dispatch = useDispatch()
    React.useEffect(()=>{
        return ()=>{
            dispatch(eventRoutines.stopFetchInviteesForEvent())
        }
    }, [])

    const Itinerary = () => (
        <Module label={'Itinerary'} name="schedule">
            <Link to={`${match.url}/itinerary`}>
                <SimpleButton icon="schedule" label="Configure itinerary" variant="outlined" />
            </Link>
        </Module>
    );

    const Discover = () => (
        <Module label={'Discover'} name="discover">
            <Link to={`${match.url}/discover`}>
                <SimpleButton icon="sort" label="Configure discover" variant="outlined" />
            </Link>
        </Module>
    );
    const ChannelsStatContent = () => {
        return (
            <Grid justify='space-between' alignItems="center" container>
                <Grid item xs={9}>
                    <Link to={isChannelsEnabled ? `${match.url}/channels` : '#'}>
                        <SimpleButton icon="chat" label="Channels" variant="outlined" />
                    </Link>
                </Grid>
                <Grid item xs={3}>
                    <SimpleToggle
                        checked={isChannelsEnabled}
                        name="channels"
                        onChange={() => updateChannelsModule(!isChannelsEnabled)}
                    />
                </Grid>
            </Grid>
        );
    };
    const PeerToPeerStatContent = () => {
        return (
            <>
                <Grid justify="space-between" alignItems="center" container>
                    <Grid item xs={9}>
                        <SimpleButton icon="chat" label="Peer To Peer" variant="outlined" />
                    </Grid>
                    <Grid item xs={3}>
                        <SimpleToggle
                            checked={isPeerToPeerEnabled}
                            name="peerToPeer"
                            onChange={() => updatePeerToPeerModule(!isPeerToPeerEnabled)}
                        />
                    </Grid>
                </Grid>
                {
                    isPeerToPeerEnabled ? (
                        <Grid alignItems="center" container>
                            <Grid item xs={9}>
                                <SimpleButton icon="video_call" label="Video Chat" variant="outlined" />
                            </Grid>
                            <Grid item xs={3}>
                                <SimpleToggle
                                    checked={isPeerToPeerVideoChatEnabled}
                                    name="peerToPeer"
                                    onChange={() => updatePeerToPeerVideoChat(!isPeerToPeerVideoChatEnabled)}
                                />
                            </Grid>
                        </Grid>
                    ) : null
                }
            </>
        );
    };
    const Inbox = () => (
        <Module label={'Inbox'} name="inbox">
            <Grid container direction="column" justify="flex-start">
                <ChannelsStatContent/>
                <Grid item>
                    <PeerToPeerStatContent></PeerToPeerStatContent>
                </Grid>
            </Grid>
        </Module>
    );
    const Moments = () => (
        <Module label={'Moments'} name="feed">
            <SimpleStat
                component={
                    <Link to={`${match.url}/moments`}>
                        <SimpleButton icon="camera_alt" label="Feed" variant="outlined" />
                    </Link>
                }
                label="Moments"
                labelType="component"
                route={`${match.url}/moments`}
                value={moduleCounts.moments}
            />
        </Module>
    );

    const Notifications = () => (
        <SimpleToggleBlock
            checked={true}
            disabled={true}
            disableToggle={true}
            label={'Notifications'}
            name="notifications"
            onSubmit={() => true}
        >
            <Link to={`${match.url}/notifications`}>
                <SimpleButton icon="mail" label="Manage Notifications" variant="outlined" />
            </Link>
        </SimpleToggleBlock>
    );

    return (
        <React.Fragment>
            <Grid container spacing={5}>
                <Grid item md={4} sm={6} xs={12}>
                    <AlertUser />
                </Grid>
                <Grid item xs>
                    <Grid item style={{ marginBottom: '20px' }} xs>
                        <UserSync
                            active_user_count={active_user_count}
                            invitee_count={invitee_count}
                            registrant_count={registrant_count}
                            updateActiveUsers={updateActiveUsers}
                        />
                    </Grid>
                    <Grid item xs>
                        <EventHero heroImage={active_event.heroImage} saveEventHeroImage={saveEventHeroImage} />
                    </Grid>
                </Grid>
                <Grid container item md={4} sm={6} spacing={3} xs={12}>
                    <Grid item xs={12}>
                        <Itinerary />
                    </Grid>
                    <Grid item xs={12}>
                        <Discover />
                    </Grid>
                    <Grid item xs={12}>
                        <Moments />
                    </Grid>
                    <Grid item xs={12}>
                        <Notifications />
                    </Grid>
                    <Grid item xs={12}>
                        <Inbox />
                    </Grid>
                    <Grid item xs={12}>
                        <SimpleToggleBlock
                            checked={true}
                            disabled={true}
                            disableToggle={true}
                            label={'Profile'}
                            name="profile"
                            onSubmit={() => true}
                        >
                            <Link to={`${match.url}/profile`}>
                                <SimpleButton icon="person" label="Configure profile settings" variant="outlined" />
                            </Link>
                        </SimpleToggleBlock>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(Dashboard);
